import IOrder_Item from "@models/IOrder_Item";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import "./KitItemsDisplay.scss";

type Props = {
    orderItem: IOrder_Item;
};

export const KitItemsDisplay = (props: Props) => {
    return (
        <div className={"KitItemsDisplay"}>
            {props.orderItem?.Kit_Items?.length ? (
                <div className={"mt-2"}>
                    <OwLabel title={"kit_items"} className={"me-2"} isBold={true} isUnderline={true} />
                    <div className={"d-flex flex-column"}>
                        {props.orderItem.Kit_Items?.map((kitItem, index) => {
                            return (
                                <div
                                    key={index}
                                    className={
                                        "kit-item-row d-flex " + (kitItem.parent_order_item_id !== props.orderItem.id ? "ms-4" : "")
                                    }>
                                    <div>
                                        [{kitItem.qty}] {kitItem.Catalog_Item?.name}
                                    </div>
                                    {kitItem.Catalog_Item?.description && <div className={"ms-2 me-2"}>-</div>}
                                    <div>{kitItem.Catalog_Item?.description}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ) : null}
        </div>
    );
};
